import React from "react";
import { RouteObject } from "react-router-dom";
import { registerModule } from "../module.register";
import { ModuleConfig } from "../module.types";
import SubscriptionPage from "./pages/SubscriptionPage";
import SubscriptionCheckoutPage from "./pages/SubscriptionCheckoutPage";
import SubscriptionConfirmationPage from "./pages/SubscriptionConfirmationPage";
import { AuthProvider } from "../auth/AuthProvider";

// Wrap components with AuthProvider
const SubscriptionPageWithAuth = () => (
  <AuthProvider>
    <SubscriptionPage />
  </AuthProvider>
);

const SubscriptionCheckoutPageWithAuth = () => (
  <AuthProvider>
    <SubscriptionCheckoutPage />
  </AuthProvider>
);

const SubscriptionConfirmationPageWithAuth = () => (
  <AuthProvider>
    <SubscriptionConfirmationPage />
  </AuthProvider>
);

const routes: RouteObject[] = [
  {
    path: "/subscription",
    element: <SubscriptionPageWithAuth />,
  },
  {
    path: "/subscription/checkout",
    element: <SubscriptionCheckoutPageWithAuth />,
  },
  {
    path: "/subscription/confirmation",
    element: <SubscriptionConfirmationPageWithAuth />,
  },
];

const subscriptionModule: ModuleConfig = {
  name: "subscription",
  routes,
};

export function registerSubscriptionModule() {
  registerModule(() => subscriptionModule);
}

registerSubscriptionModule(); 